import { UpdateQuestionForStoryMeta, UpdateQuestionForStoryPayload } from 'types/store/UpdateQuestionForStory';
import { createAsyncReducer } from 'utils/Redux';

import { updateQuestionForStoryActions } from '../actions';

export default createAsyncReducer<UpdateQuestionForStoryMeta, UpdateQuestionForStoryPayload>(updateQuestionForStoryActions);
